import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";
import Loader from "@/components/Loader";
import usePageTitle from "@/hooks/usePageTitle";

export default function About() {
  const [profile, setProfile] = useState(null);
  usePageTitle("About", "Biography, leadership journey and recognition of Shri Nitin Narang — President of the All India Chess Federation, Founder & CEO of The Ideaz Factory.");

  useEffect(() => {
    client.get("/profile").then(r => setProfile(r.data));
  }, []);

  if (!profile) return <Loader label="Loading biography" />;

  const paragraphs = profile.long_bio.split("\n\n");

  return (
    <main className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 mb-20">
        <div className="lg:col-span-7">
          <div className="eyebrow mb-4">Biography</div>
          <h1 className="serif-title text-5xl lg:text-6xl text-[#0a1628] mb-6">
            A founder's pace,<br/><span className="italic text-[#b8975d]">in a public institution.</span>
          </h1>
          <p className="text-[#4a4a4a] text-[18px] leading-relaxed max-w-2xl">
            {profile.medium_bio}
          </p>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] bg-[#ece7da] overflow-hidden border hairline">
            {profile.hero_image && <img src={profile.hero_image} alt="Nitin Narang" className="w-full h-full object-cover" />}
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-8 prose-body">
          <div className="eyebrow mb-4">The full biography</div>
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>

        <aside className="lg:col-span-4 space-y-8">
          <div className="border hairline p-7 bg-white">
            <div className="eyebrow mb-4">Public values</div>
            <ul className="space-y-5">
              {profile.values?.map((v, i) => (
                <li key={i}>
                  <div className="font-display text-lg text-[#0a1628] mb-1">{v.title}</div>
                  <div className="text-[13px] text-[#6b6b6b] leading-relaxed">{v.body}</div>
                </li>
              ))}
            </ul>
          </div>

          <div className="border hairline p-7 bg-white">
            <div className="eyebrow mb-4">Quick facts</div>
            <dl className="space-y-3 text-[14px]">
              <div className="flex justify-between gap-4 border-b hairline pb-3">
                <dt className="text-[#6b6b6b]">Office</dt><dd className="text-[#0a1628] text-right">President, AICF</dd>
              </div>
              <div className="flex justify-between gap-4 border-b hairline pb-3">
                <dt className="text-[#6b6b6b]">Term</dt><dd className="text-[#0a1628]">2024 – 2027</dd>
              </div>
              <div className="flex justify-between gap-4 border-b hairline pb-3">
                <dt className="text-[#6b6b6b]">Hometown</dt><dd className="text-[#0a1628]">Karnal, Haryana</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-[#6b6b6b]">Firm</dt><dd className="text-[#0a1628] text-right">The Ideaz Factory</dd>
              </div>
            </dl>
          </div>

          <Link to="/media-kit" className="btn w-full justify-center">Download Media Kit</Link>
        </aside>
      </div>

      {/* Timeline */}
      <section className="mt-28">
        <div className="eyebrow mb-4">Timeline · Key milestones</div>
        <h2 className="serif-title text-4xl lg:text-5xl text-[#0a1628] mb-12">Leadership journey.</h2>
        <div className="relative border-l hairline pl-8 space-y-10">
          {profile.timeline?.map((t, i) => (
            <div key={i} className="relative">
              <span className="absolute -left-[42px] top-1 w-3 h-3 bg-[#b8975d] rounded-full ring-4 ring-[#faf8f3]"></span>
              <div className="eyebrow text-[#b8975d] mb-1">{t.year}</div>
              <h3 className="font-display text-2xl text-[#0a1628] mb-2">{t.title}</h3>
              <p className="text-[#4a4a4a] text-[15px] leading-relaxed max-w-2xl">{t.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* RECOGNITION */}
      {profile.recognition?.length > 0 && (
        <section className="mt-28">
          <div className="eyebrow mb-4">Recognition · Public record</div>
          <h2 className="serif-title text-4xl lg:text-5xl text-[#0a1628] mb-12">
            Milestones in <span className="italic text-[#b8975d]">public office.</span>
          </h2>
          <div className="grid md:grid-cols-2 gap-5">
            {profile.recognition.map((r, i) => (
              <div key={i} className="border hairline bg-white p-7 card-hover">
                <div className="flex items-baseline gap-3 mb-3">
                  <span className="font-display text-2xl text-[#b8975d]">{r.year}</span>
                  <span className="text-[10px] tracking-[0.22em] uppercase text-[#6b6b6b]">{r.source}</span>
                </div>
                <h3 className="font-display text-xl text-[#0a1628] mb-2 leading-snug">{r.title}</h3>
                <p className="text-[13px] text-[#4a4a4a] leading-relaxed">{r.body}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </main>
  );
}
